/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFireSymbol: {
  name: 'fire_symbol';
  data: string;
} = {
  name: 'fire_symbol',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M91.333 220.208c-4.184 20.132-16.734 22.141 0 36.233 16.735-14.092 4.184-16.101 0-36.233zm-10.459 12.066c-2.092 6.039-6.275 10.097-6.275 16.137 0 6.039 8.367 10.048 14.643 10.048-12.551-10.067-8.368-16.12-8.368-26.185zm20.918 0c0 10.066 4.184 16.119-8.367 26.185 6.275 0 14.643-4.009 14.643-10.048 0-6.04-4.184-10.098-6.276-16.137z" transform="matrix(15 0 0 15 -1064 -3284)"/></svg>`,
};
